<div class="notifications-wrapper">
  <div class="toolbar-row" *ngIf="receivedNotifications && allNotifications.length > 0">
    <div class="show-unread-toggle">
      <p-inputSwitch [(ngModel)]="showUnreadOnly" (onChange)="onShowUnreadToggle()"></p-inputSwitch>
      <span class="show-unread-label">Show Unread only</span>
      <span
        *ngIf="unreadCount > 0"
        class="unread-badge"
        [pTooltip]="'You have ' + unreadCount + ' unread notification' + (unreadCount > 1 ? 's' : '')"
        tooltipPosition="top"
      >{{ unreadCount }}</span>
    </div>
    <button
      *ngIf="tlmAlarms.length > 0 && canAcknowledgeAlarms"
      type="button"
      class="tlm-ack-all"
      [disabled]="isAcknowledgingAll"
      pTooltip="Acknowledge all my open alarms at all my locations — requests stay"
      tooltipPosition="bottom"
      (click)="acknowledgeAllAlarms()"
    >
      <i class="pi pi-check-circle"></i> Acknowledge all alarms ({{ tlmAlarms.length }})
    </button>
    <gs-share-feedback-button *ngIf="isPdp"></gs-share-feedback-button>
  </div>
  <gs-share-feedback-button *ngIf="isPdp && !receivedNotifications"></gs-share-feedback-button>
  <div class="notifications-container">
    <div
      *ngIf="notifications.length === 0 && groupedNotificationKeys.length === 0 && pinnedNotifications.length === 0"
    >
      <div class="empty-state">
        <p>No notifications to display.</p>
      </div>
    </div>

    <!-- Header with NEW button and filter for created notifications (!receivedNotifications) -->
    <div class="global-header" *ngIf="!receivedNotifications">
      <button
        type="button"
        pButton
        class="p-element edit p-button p-component create-notification"
        pTooltip="Create new notification"
        style="height: 30px; font-size:14px;"
        (click)="onToogleAddNotification()"
      >
        <span
          class="p-button-icon p-button-icon-left fas fa-plus bold"
          aria-hidden="true"
        ></span>
        NEW
      </button>
      <span class="notification-filter-dropdown-created-by">
        <p-multiSelect
          *ngIf="notificationTypeFilters.length > 0"
          [options]="notificationTypeFilters"
          [(ngModel)]="selectedFilters"
          (onChange)="onFilterChange()"
          optionLabel="name"
          [filter]="false"
          [showHeader]="false"
          placeholder="Filter"
          styleClass="notification-filter-dropdown"
          panelStyleClass="notification-filter-panel"
          appendTo="body"
          [style]="{ 'min-width': '150px' }"
          [showToggleAll]="false"
          display="chip"
        >
          <ng-template pTemplate="selectedItems">
            <div class="filter-button-display">
              <i class="pi pi-filter"></i>
              <span>Filter</span>
            </div>
          </ng-template>

          <ng-template let-filter pTemplate="item">
            <div
              class="filter-dropdown-item"
            >
              <p-checkbox
                [(ngModel)]="filter.selected"
                [binary]="true"
                [inputId]="'filter-header-created-' + filter.code"
                (click)="onFilterItemClick($event, filter)"
              ></p-checkbox>
              <i
                class="pi filter-icon"
                [ngClass]="filter.iconClass"
                [style.background-color]="filter.iconBackgroundColor"
              ></i>
              <span class="filter-name">{{ filter.name }}</span>
            </div>
          </ng-template>
        </p-multiSelect>
      </span>
    </div>
    <!-- Header with filter only for received notifications (receivedNotifications) -->
    <div class="global-header global-header--received" *ngIf="receivedNotifications && allNotifications.length > 0">
      <p-multiSelect
        *ngIf="notificationTypeFilters.length > 0"
        [options]="notificationTypeFilters"
        [(ngModel)]="selectedFilters"
        (onChange)="onFilterChange()"
        optionLabel="name"
        [filter]="false"
        [showHeader]="false"
        placeholder="Filter"
        styleClass="notification-filter-dropdown"
        panelStyleClass="notification-filter-panel"
        appendTo="body"
        [style]="{ 'min-width': '150px' }"
        [showToggleAll]="false"
        display="chip"
      >
        <ng-template pTemplate="selectedItems">
          <div class="filter-button-display">
            <i class="pi pi-filter"></i>
            <span>Filter</span>
          </div>
        </ng-template>

        <ng-template let-filter pTemplate="item">
          <div
            class="filter-dropdown-item"
            (click)="onFilterItemClick($event, filter)"
          >
            <p-checkbox
              [(ngModel)]="filter.selected"
              [binary]="true"
              [inputId]="'filter-header-received-' + filter.code"
              (click)="onFilterItemClick($event, filter)"
            ></p-checkbox>
            <i
              class="pi filter-icon"
              [ngClass]="filter.iconClass"
              [style.background-color]="filter.iconBackgroundColor"
            ></i>
            <span class="filter-name">{{ filter.name }}</span>
          </div>
        </ng-template>
      </p-multiSelect>
    </div>
    <!-- FENIKS US-10.5 (AC-8): alarms, then requests — in the server's order, pinned above everything else, no group headers -->
    <div class="tlm-pinned" *ngIf="receivedNotifications && pinnedNotifications.length > 0">
      <app-notification-item
        *ngFor="let notification of pinnedNotifications"
        [notification]="notification"
        [footerFields]="[]"
        [receivedNotifications]="true"
        [tlmKind]="notification.tlmKind || null"
        [canAcknowledge]="canAcknowledgeAlarms"
        (viewDetails)="onViewDetailsClick($event)"
        (acknowledge)="acknowledgeAlarm($event)"
        (remove)="removeTlmItem($event)"
      >
      </app-notification-item>
    </div>

    <div
      class="tlm-divider"
      *ngIf="receivedNotifications && pinnedNotifications.length > 0 && groupedNotificationKeys.length > 0"
    ></div>

    <div
      *ngFor="let dateKey of groupedNotificationKeys"
      class="date-group"
    >
      <div class="date-header">
        <h2 class="date-text">{{ dateKey }}</h2>
      </div>

      <div>
        <ng-container *ngFor="let notification of groupedNotifications[dateKey]; let last = last">
          <div [style.border-bottom]="last ? '1px dashed #e8e4e4' : 'none'">
            <app-notification-item
              [notification]="notification"
              [footerFields]="getFooterFields(notification)"
              [isIndicatorVisible]="
                notification.notificationInstance.PK_ID === activeNotificationId
              "
              (toggle)="toggleNotification($event)"
              (toggleReadStatus)="
                toggleReadStatus($event.notification, $event.event)
              "
              (viewConversation)="onViewConversationClick($event)"
              (viewDetails)="onViewDetailsClick($event)"
              (openLinkRequested)="openLink($event)"
              [receivedNotifications]="receivedNotifications"
              (remove)="removeNotification($event)"
              (delete)="deleteNotification($event)"
              (updateNotificationStatus)="notificationStatusChanged($event)"
            >
            </app-notification-item>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<p-dialog
  *ngIf="showAddNotificationDialog"
  [(visible)]="showAddNotificationDialog"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [modal]="true"
  contentStyleClass="dialog-relative"
  header="Create new notification"
  [style]="{ width: '25%', height: '80%' }"
>
  <app-create-notification
    [loadData]="showAddNotificationDialog"
    (notificationCreated)="onNotificationCreated($event)"
  ></app-create-notification>
</p-dialog>
